import { createFileRoute } from "@tanstack/react-router";

import { USER_QUERY } from "@/features/users/graphql/user-query";
import { User } from "@/features/users/user";

export const Route = createFileRoute("/_authenticated/users/$id")({
  component: User,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(USER_QUERY, { id: params.id }).toPromise();
    }
  },
});
